import React from 'react';

const AsyncProgramList = React.lazy(() => import('./ListContainer'));

export const TvProgramList = () => {
  return <AsyncProgramList />;
};
